import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "custom-product-checkout" */ './CustomProductCheckoutCtnr'));
